<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demo-basic-card">
        <div class="vx-row" style="padding:10px">
          <spaceItem v-for="space in workspaceList" :spaceInfo="space"  v-bind:key="space.id"/>
        </div>
    </div>
</template>

<script>
import SpaceItem from "@/views/apps/space/SpaceItem.vue"

export default{
    components: {
        'spaceItem': SpaceItem,
    },
    data() {
        return {
          chatMsgInput: '',
          settings: {
              type: 'shadow',
          },
          workspaceList: []
      }
    },
    watch: {
      "$store.state.space.checkboxClassState"() {
        if(!this.$store.state.space.checkboxClassState && !this.$store.state.space.checkboxAloneState){
          this.workspaceList = []
        } else{
          this.workspaceList =  this.$store.getters['space/filteredWorkspace']
        }
      },
      "$store.state.space.checkboxAloneState"() {
        if(!this.$store.state.space.checkboxClassState && !this.$store.state.space.checkboxAloneState){
          this.workspaceList = []
        } else{
          this.workspaceList =  this.$store.getters['space/filteredWorkspace']
        }
      }
    },
    computed: {
      getWorkspace() {
        return this.$store.getters['space/filteredWorkspace']
      },
    },
    methods: {
      comp(val1, val2){
        return val1.update_time > val2.update_time;
      }
    },
    created() {
      this.workspaceList =  this.$store.getters['space/filteredWorkspace']
    }
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 705px;
        }
    }
 }
</style>
